import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { MyContext, ListContext } from "./MyContext";

// import AuthHelperMethods from "./AuthHelperMethods";
import { timeISOtoString } from "./momentUtils";
import COLORS from "./styleConstants";

import moment from "moment";
import { dateISOtoStringMed } from "./momentUtils";
import { useAlert } from "react-alert";
import { ButtonBlue, ButtonOrange, CheckBoxSquare } from "./formComponents";
import "react-datepicker/dist/react-datepicker.css";

import { Info } from "./Calendar";

import Auth from "./Auth";
import { ERROR_MESSAGES } from "./errorMessages";

const BookingCalendar = (props) => {
  const { listState, dispatch2 } = useContext(ListContext);
  const { mystate, dispatch, setGlobalError } = useContext(MyContext);
  const alert = useAlert();
  const history = useHistory();
  //const [makeups, setMakeups] = useState([]);
  const [useMakeup, setUseMakeup] = useState(false); //todo create farmDefaultSetting for this
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [offlineLocked, setOfflineLocked] = useState(false);

  useEffect(() => {
    const handleOnline = () => setOfflineLocked(false);
    window.addEventListener("online", handleOnline);
    return () => window.removeEventListener("online", handleOnline);
  }, []);

  useEffect(
    () => {
      return () => {
        dispatch2(["SET_CURRENT_BOOKING_LESSON", {}]);
      };
    },
    //eslint-disable-next-line
    [],
  );

  const lessonInWords = (lesson) => {
    let msg = `${listState.currentClient.person_name} has been booked for ${
      lesson.title
    } on ${dateISOtoStringMed(lesson.scheduled_date)} ${
      !lesson.is_allday
        ? " at " + timeISOtoString(lesson.scheduled_starttime)
        : ""
    }  with ${lesson.instructor_name}.`;
    return msg;
  };
  const addStudentToCalendarLesson = async () => {
    if (isSubmitting) return;

    if (!navigator.onLine) {
      setOfflineLocked(true);
      setGlobalError({
        message: ERROR_MESSAGES.OFFLINE_POST,
        persist: true,
        showButtons: false,
        source: "post",
      });
      return;
    }

    setIsSubmitting(true);
    let didNavigateAway = false;
    //  setStudentBooking(true);
    let lessonToBook = listState.currentBookingLesson;
    console.log(lessonToBook);
    let params = {};
    params.id = lessonToBook.id;
    params.instructor_id = lessonToBook.instructor_id;
    params.lesson_date_time_id = lessonToBook.id;
    params.student_id = listState.currentClient.student_id;
    params.student_email = listState.accountHolder.contact_email;
    params.person_id = listState.currentClient.id;
    params.account_name = listState.accountHolder.first_name;
    params.makeup_lesson_id = listState.currentClient.makeup_lesson_id || null; //?this doesn't make sense -> doesn't exist
    params.dont_check_availability = true; //? need this
    params.scheduled_date = lessonToBook.scheduled_date;
    params.use_makeup = useMakeup;
    params.msg = lessonInWords(lessonToBook);
    console.log(params);

    try {
      //  dispatch({ type: "FETCH_INIT" });
      console.log("INIT");

      const result = await Auth.api(
        "lesson_people/addStudentToLesson",
        "post",
        params,
      );
      console.log("WAITING FOR RESULT");

      if (result) {
        //  dispatch({ type: "FETCH_SUCCESS" });

        if (result.data.lessonPerson == "already in lesson") {
          // dispatch2(["SET_DIALOG_SHOW", true]);
          alert.show("Student is already booked for this lesson spot");
          //  setStudentBooking(false);
          didNavigateAway = true;
          history.goBack();
        } else if (result.data.lessonPerson == "none available") {
          // setStudentBooking(false);
          didNavigateAway = true;
          history.goBack();
          alert.show("No spots available for this lesson");
        } else {
          dispatch2(["SET_SEARCH_FILTER", moment().format(), "timetorefresh"]);
          // setRefresh(!refresh);
          //  setStudentBooking(false);

          didNavigateAway = true;
          history.goBack();
          alert.show(lessonInWords(lessonToBook), {
            timeout: 5000,
            type: "success",
          });
        }
      } else {
        dispatch({ type: "FETCH_ERROR" });
      }
    } catch (error) {
      dispatch({ type: "FETCH_ERROR" });

      console.error(error.message);
    } finally {
      if (!didNavigateAway) setIsSubmitting(false);
    }
  };
  return (
    <>
      <h1>Booking Calendar</h1>
      <Modal show={true} size="md" centered>
        <Modal.Header style={{ background: COLORS.blue, color: "white" }}>
          <Modal.Title>
            {`Add ${listState.currentClient.person_name} To This Lesson?`}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ color: COLORS.blue, fontSize: 16 }}>
            {dateISOtoStringMed(listState.currentBookingLesson.scheduled_date)}
          </div>
          <Info currentevent={listState.currentBookingLesson} />

          <CheckBoxSquare
            check={useMakeup}
            onClick={() => setUseMakeup(!useMakeup)}
            label={"Use makeup if available?"}
          />
        </Modal.Body>
        <Modal.Footer>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flex: "1 1 100%",
            }}
          >
            <ButtonOrange
              onClick={() => addStudentToCalendarLesson()}
              disabled={isSubmitting || offlineLocked}
              label={isSubmitting ? "Adding..." : "Add"}
            />
            <ButtonBlue onClick={() => history.goBack()} label={"Cancel"} />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BookingCalendar;
